<nav class="navbar fixed-top header-navbar">
  <div class="d-flex align-items-center">
    <a (click)="menuButtonClick($event, sidebar.menuClickCount, sidebar.containerClassnames); false;"
      href="javascript:;" class="menu-button d-none d-md-block">
      <svg class="main" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 17">
        <rect x="0.48" y="0.5" width="7" height="1" />
        <rect x="0.48" y="7.5" width="7" height="1" />
        <rect x="0.48" y="15.5" width="7" height="1" />
      </svg> {{" "}}
      <svg class="sub" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17">
        <rect x="1.56" y="0.5" width="16" height="1" />
        <rect x="1.56" y="7.5" width="16" height="1" />
        <rect x="1.56" y="15.5" width="16" height="1" />
      </svg>
    </a>

    <a (click)="mobileMenuButtonClick($event, sidebar.containerClassnames)" href="javascript:;"
      class="menu-button-mobile d-xs-block d-sm-block d-md-none">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 17">
        <rect x="0.5" y="0.5" width="25" height="1" />
        <rect x="0.5" y="7.5" width="25" height="1" />
        <rect x="0.5" y="15.5" width="25" height="1" />
      </svg>
    </a>

    <a class="navbar-logo" href="apphome/dashboard" >
      <span class="logo d-none d-xs-block">
      </span><span class="logo-mobile d-block d-xs-none"></span>
    </a>
  </div>

  <div class="header-text">
    <span class="welcome-wrapper">Welcome, {{selectedUser?.Name}}</span>
  </div>

  <div class="navbar-right">

    <div class="user d-inline-block" dropdown>
      <button class="btn btn-empty p-0 no_border" type="button" dropdownToggle>
        <span class="col_grey">{{selectedUser?.Name}}</span>
        <span>
          <img class="img-wrapper" alt="Profile Picture" src="/assets/images/no-image.png" />
        </span>
      </button>

      <div class="dropdown-menu dropdown-menu-right mt-3" *dropdownMenu role="menu">
        <a class="dropdown-item c-pointer" (click)="navigateToProfile()">Profile</a>
        <li class="divider dropdown-divider"></li>
        <a class="dropdown-item c-pointer" (click)="navigateToChangePassword()">Change Password</a>
        <li class="divider dropdown-divider"></li>
        <a class="dropdown-item c-pointer" (click)="onSignOut()">Sign out</a>
      </div>
    </div>

  </div>

</nav>
